import React from 'react';

import useOutsideAlerter, { OutsideAlerterProps } from './hooks';

type Props = OutsideAlerterProps & {
  children: React.JSX.Element | React.JSX.Element[];
};

const OutsideAlerter = ({ children, funcDelegate }: Readonly<Props>): React.JSX.Element => {
  const { wrapperRef } = useOutsideAlerter({ funcDelegate });

  return <div ref={wrapperRef}>{children}</div>;
};

export default OutsideAlerter;
